import React from "react";
import { useSelector } from "react-redux";
import moment from 'moment';
import classes from './SummativeAssessmentAndRejectedView.module.css';
import { onKeyDown } from "../../../../../../service.js";
import CheckIcon from '../../../../../../assests/assessments/check.png';
import AssessmentFeedback from "../../../../../lms-shared/AssessmentFeedback/AssessmentFeedback";

const SummativeAssessmentAndRejectedView = ({
    submissionData,
    remarks,
    dynamicIndicatorObj,
    setEditData,
    nextAssessment,
    scoreAdditionalData,
    title1,
    title2 }) => {

    const { texts } = useSelector(state => state.translate);

    const correct = () => {
        setEditData(true);
    }

    const getStatusChangeDate = () => {
        if (submissionData) {
            if (submissionData.feedbackDate)
                return moment(submissionData.feedbackDate).format('DD.MM.YYYY');
            if (submissionData.statusChangedDate)
                return moment(submissionData.statusChangedDate).format('DD.MM.YYYY');
        }
        return moment().format('DD.MM.YYYY');
    }

    return (
        <>
            <div className={classes.StatusTitle}>
                <img src={CheckIcon} />
                <div>{title1}&nbsp;|&nbsp;</div>
                <div>{getStatusChangeDate()}</div>
            </div>
            <div className={classes.StatusContainer}>
                {submissionData?.submittedByUser?.isGroup ?
                    <div className={classes.AssessmentTitle}>{submissionData.submittedByUser.name}: {submissionData.submittedByUser.users?.map(s => s.firstName + ' ' + s.lastName).join(', ')}&nbsp;|&nbsp;{submissionData.assessmentName}&nbsp;|&nbsp;{getStatusChangeDate()}</div> :
                    <div className={classes.AssessmentTitle}>{submissionData?.submittedByUser?.firstName} {submissionData?.submittedByUser?.lastName}&nbsp;|&nbsp;{submissionData?.assessmentName}&nbsp;|&nbsp;{getStatusChangeDate()}</div>
                }
                <div className={classes.Hr}></div>
                <div className={classes.StatusTitle2}>{title2}</div>
                <AssessmentFeedback
                    submissionStatusId={submissionData?.submissionStatusId}
                    remarks={remarks}
                    SCORE_EXAMPLE={dynamicIndicatorObj.scoreOptions}
                    scoreAdditionalData={scoreAdditionalData}
                    submittedByUser={submissionData?.submittedByUser}
                ></AssessmentFeedback>
                <div className={classes.AssessmentCorrection} onClick={correct} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, correct)}>{texts.assessmentCorrection}</div>

            </div>
            <div className={classes.SubmitBtnWrap}>
                {nextAssessment && <button className={classes.SubmitBtn} onClick={nextAssessment}>{texts.nextAssessment}</button>}
            </div>
        </>
    )
}

export default SummativeAssessmentAndRejectedView;